import { Observable} from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { SsoAccountCheckoutState, SsoAccountData } from "../domain/models/sso-account.model";
import { ConfigService } from "../../../../lib/config/config.service";

@Injectable({ providedIn: "root" })
export class SsoAccountRemote {
  constructor(
    private readonly http: HttpClient,
    private readonly configService: ConfigService,
  ) {}

  getCurrent(): Observable<SsoAccountData> {
    const url = `${this.configService.environment.oauth.url}/api/accounts/current`;
    return this.http.get<SsoAccountData>(url, {
      headers: this.configService.environment.cache.noCache,
    });
  }

  getCheckoutState(): Observable<SsoAccountCheckoutState> {
    const url = `${this.configService.environment.customers.url}/api/checkout/state`;
    return this.http.get<SsoAccountCheckoutState>(url);
  }
}
